import { Serializer } from "../resource/serializer.interface";
import { Contact } from "./contact.model";

export class ContactSerializer implements Serializer {
    fromJson(json: any): Contact {
        const contact = new Contact();
        contact.id = json.id;
        contact.emailAddress = json.emailAddress;
        contact.tenantId = json.tenant_id;
        return contact;
    }

    toJson(contact: Contact): any {
        return {
            id: contact.id,
            emailAddress: contact.emailAddress,
            tenant_id: contact.tenantId
        };
    }
}
